/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _password__minimum_char_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'n',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' caractère minimum' }] },
                other: {
                    value: [{ type: 7 }, { type: 0, value: ' caractères minimum' }],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

const _password__minimum_char_en = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'n',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' character minimum' }] },
                other: {
                    value: [{ type: 7 }, { type: 0, value: ' characters minimum' }],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'en',
);

export function password__minimum_char(args: { n: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _password__minimum_char_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _password__minimum_char_en.format(args) as unknown as string;
    }

    return _password__minimum_char_fr.format(args) as unknown as string;
}

const _password__at_least_one_uppercase_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Au moins une majuscule' }],
    'fr',
);

const _password__at_least_one_uppercase_en = new IntlMessageFormat(
    [{ type: 0, value: 'At least one uppercase' }],
    'en',
);

export function password__at_least_one_uppercase(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _password__at_least_one_uppercase_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _password__at_least_one_uppercase_en.format(args) as unknown as string;
    }

    return _password__at_least_one_uppercase_fr.format(args) as unknown as string;
}

const _password__at_least_one_lowercase_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Au moins une minuscule' }],
    'fr',
);

const _password__at_least_one_lowercase_en = new IntlMessageFormat(
    [{ type: 0, value: 'At least one lowercase' }],
    'en',
);

export function password__at_least_one_lowercase(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _password__at_least_one_lowercase_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _password__at_least_one_lowercase_en.format(args) as unknown as string;
    }

    return _password__at_least_one_lowercase_fr.format(args) as unknown as string;
}

const _password__at_least_one_digit_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Au moins un chiffre' }],
    'fr',
);

const _password__at_least_one_digit_en = new IntlMessageFormat(
    [{ type: 0, value: 'At least one digit' }],
    'en',
);

export function password__at_least_one_digit(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _password__at_least_one_digit_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _password__at_least_one_digit_en.format(args) as unknown as string;
    }

    return _password__at_least_one_digit_fr.format(args) as unknown as string;
}

const _password__must_be_valid_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vous devez saisir un mot de passe valide' }],
    'fr',
);

const _password__must_be_valid_en = new IntlMessageFormat(
    [{ type: 0, value: 'You must enter a valid password' }],
    'en',
);

export function password__must_be_valid(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _password__must_be_valid_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _password__must_be_valid_en.format(args) as unknown as string;
    }

    return _password__must_be_valid_fr.format(args) as unknown as string;
}

const _firstname__is_required_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vous devez saisir votre prénom' }],
    'fr',
);

const _firstname__is_required_en = new IntlMessageFormat(
    [{ type: 0, value: 'You must enter your first name' }],
    'en',
);

export function firstname__is_required(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _firstname__is_required_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _firstname__is_required_en.format(args) as unknown as string;
    }

    return _firstname__is_required_fr.format(args) as unknown as string;
}

const _firstname__is_too_long_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Le prénom est trop long.' }],
    'fr',
);

const _firstname__is_too_long_en = new IntlMessageFormat(
    [{ type: 0, value: 'The first name is too long.' }],
    'en',
);

export function firstname__is_too_long(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _firstname__is_too_long_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _firstname__is_too_long_en.format(args) as unknown as string;
    }

    return _firstname__is_too_long_fr.format(args) as unknown as string;
}

const _lastname__is_required_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vous devez saisir votre nom de famille' }],
    'fr',
);

const _lastname__is_required_en = new IntlMessageFormat(
    [{ type: 0, value: 'You must enter your last name' }],
    'en',
);

export function lastname__is_required(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _lastname__is_required_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _lastname__is_required_en.format(args) as unknown as string;
    }

    return _lastname__is_required_fr.format(args) as unknown as string;
}

const _lastname__is_too_long_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Le nom est trop long.' }],
    'fr',
);

const _lastname__is_too_long_en = new IntlMessageFormat(
    [{ type: 0, value: 'The name is too long.' }],
    'en',
);

export function lastname__is_too_long(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _lastname__is_too_long_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _lastname__is_too_long_en.format(args) as unknown as string;
    }

    return _lastname__is_too_long_fr.format(args) as unknown as string;
}

const _email__must_be_valid_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vous devez saisir une adresse email valide' }],
    'fr',
);

const _email__must_be_valid_en = new IntlMessageFormat(
    [{ type: 0, value: 'You must enter a valid email address' }],
    'en',
);

export function email__must_be_valid(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _email__must_be_valid_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _email__must_be_valid_en.format(args) as unknown as string;
    }

    return _email__must_be_valid_fr.format(args) as unknown as string;
}

const _email__is_too_long_fr = new IntlMessageFormat(
    [
        { type: 0, value: "L'email dépasse la limite de caractères autorisée (" },
        {
            type: 6,
            value: 'max',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' caractères' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' caractères' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: ' maximum).' },
    ],
    'fr',
);

const _email__is_too_long_en = new IntlMessageFormat(
    [
        { type: 0, value: 'The email exceeds the allowed character limit (' },
        {
            type: 6,
            value: 'max',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' character' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' characters' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: ' maximum).' },
    ],
    'en',
);

export function email__is_too_long(args: { max: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _email__is_too_long_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _email__is_too_long_en.format(args) as unknown as string;
    }

    return _email__is_too_long_fr.format(args) as unknown as string;
}

const _email__already_used_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Email déjà utilisé' }],
    'fr',
);

const _email__already_used_en = new IntlMessageFormat(
    [{ type: 0, value: 'Email already in use' }],
    'en',
);

export function email__already_used(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _email__already_used_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _email__already_used_en.format(args) as unknown as string;
    }

    return _email__already_used_fr.format(args) as unknown as string;
}

const _accept_cgu_and_rgpd__is_required_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Vous devez acceptez les CGU et la politique de protection des données personnelles avant de continuer.',
        },
    ],
    'fr',
);

const _accept_cgu_and_rgpd__is_required_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'You must accept the Terms of Service and Personal Data Protection Policy before continuing.',
        },
    ],
    'en',
);

export function accept_cgu_and_rgpd__is_required(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _accept_cgu_and_rgpd__is_required_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _accept_cgu_and_rgpd__is_required_en.format(args) as unknown as string;
    }

    return _accept_cgu_and_rgpd__is_required_fr.format(args) as unknown as string;
}
